/* eslint-disable no-console */
import { updateAccountIconStatus } from './consumer-account/account-nav-icon';
import { getAccountData } from './consumer-account/account-api';

const swatchbookLsObj = 'bali_swbk';
let swatchbookData;

const getItemById = (id) => {
  if (!swatchbookData) {
    swatchbookData = getSwatchbookData(); /* eslint-disable-line no-use-before-define */
  }
  const item = swatchbookData.items.find(saved => saved.id === id);
  if (item !== undefined) {
    return item;
  }
  return null;
};

// We're only saving the portion of the url AFTER springswindowfashions/
const getTruncatedWidenUrl = (url) => {
  if (url.indexOf('springswindowfashions/') !== -1) {
    return url.split('springswindowfashions/')[1];
  }
  return url;
};

const encodeSwatchModalTableDataById = (id) => {
  const div = document.createElement('div');
  let s = '';
  div.classList.add('hidden');
  div.innerHTML = document.querySelector(`#${id} .image-wrapper`).dataset.imageStory;
  document.getElementsByTagName('body')[0].appendChild(div);
  const trList = div.getElementsByTagName('table')[0].querySelectorAll('tr');
  let tr;
  for (let i = 0; i < trList.length; i++) { /* eslint-disable-line no-plusplus */
    tr = trList[i];
    if (tr.querySelector('.lightbox-label')) {
      s += `${tr.querySelector('.lightbox-label').innerText},,`;
    }
    if (tr.querySelector('.lightbox-value')) {
      s += tr.querySelector('.lightbox-value').innerText;
    }
    s += ';;';
  }
  document.getElementsByTagName('body')[0].removeChild(div);
  return s;
};

const decodeSwatchModalTableDataById = (data) => {
  const arr = data.split(';;');
  let td = [];
  let rows = '';
  let className = '';
  arr.forEach((tr) => {
    rows += '<tr>';
    td = tr.split(',,');
    td.forEach((str, index) => {
      if (index === 0 && td.length === 2) {
        className = 'lightbox-label';
      } else {
        className = 'lightbox-value';
      }
      rows += `<td class='${className}'>${str}</td>`;
    });
    rows += '</tr>';
  });
  return rows.replace(/"/g, '&quot;');
};

const isEmpty = () => {
  if (swatchbookData.items.length === 0) {
    return true;
  }
  return false;
};

const updateNavIcon = () => {
  // Do not update icon if window.useLocalStorage = false and window.isAuthenticated = false
  if (!window.useLocalStorage && !window.isAuthenticated) {
    return;
  }
  let icon = document.querySelector('.my-account-item');
  if (icon === null) {
    icon = document.querySelector('.my-favorites-item');
  }
  const addedClass = 'items-added-to-swatchbook';
  if (icon === null) {
    return;
  }
  if (isEmpty()) {
    icon.classList.remove(addedClass);
  } else {
    icon.classList.add(addedClass);
  }
};

const getSwatchbookData = () => {
  let data = JSON.parse(window.localStorage.getItem(swatchbookLsObj));
  if (data === null) {
    // Set up an empty data object
    data = { items: [], cart: [], order: [] };
  } else {
    /* eslint-disable no-lonely-if */
    if (data.order === undefined) {
      data.order = [];
    }
    /* eslint-enable no-lonely-if */
  }
  return data;
};

const getUserData = (callback) => {
  getAccountData(callback);
};

const saveItem = (options) => {
  switch (options.type) {
    case 'swatch':
      break;
    case 'photo':
      options.id = window.widenUtils.getIdFromAssetUrl(options.imageUrl);
      break;
    case 'location':
      options.id = 'dealer';
      break;
    default:
      break;
  }
  if (getItemById(options.id) !== null) {
    console.log(`${options.id} already in swatchbook.`);
    return;
  }
  // Add timestamp
  options.page = window.location.href;
  options.dateSaved = Date.now();
  swatchbookData.items.push(options);
  window.localStorage.setItem(swatchbookLsObj, JSON.stringify(swatchbookData));
  updateAccountIconStatus();

  if (options.type === 'photo' && options.description == null) {
    window.widenUtils.setAssetCaption(options.id, options.imageUrl);
  }
};

const removeItem = (type, val) => {
  let id;
  switch (type) {
    case 'swatch':
      id = val;
      break;
    case 'photo':
      id = window.widenUtils.getIdFromAssetUrl(val);
      break;
    case 'location':
      id = val;
      break;
    case 'visualization':
      id = val;
      break;
    default:
      break;
  }
  const at = swatchbookData.items.findIndex(saved => saved.id === id);
  if (at !== undefined) {
    // Remove item
    swatchbookData.items.splice(at, 1);
    console.log(`${id} removed from swatchbook.`);
    // Update data object in storage
    window.localStorage.setItem(swatchbookLsObj, JSON.stringify(swatchbookData));
  }
  updateAccountIconStatus();
};

const getAllOfType = (type) => {
  if (!swatchbookData) {
    return [];
  }
  const arr = swatchbookData.items.filter(item => item.type === type);
  return arr;
};

const saveSwatchbookItem = (options) => {
  if (options.type === 'swatch') {
    options.modalData = encodeSwatchModalTableDataById(options.id);
  }
  if (getItemById(options.id) === null) {
    options.page = window.location.href;
    options.dateSaved = Date.now();
    swatchbookData.items.push(options);
    window.localStorage.setItem(swatchbookLsObj, JSON.stringify(swatchbookData));
    updateNavIcon();
  }
};

const removeSwatchbookItem = (options) => {
  let id;
  switch (options.type) {
    case 'swatch':
      id = options.value;
      break;
    case 'photo':
      id = options.value;
      break;
    default:
      break;
  }
  const at = swatchbookData.items.findIndex(saved => saved.id === id);
  if (at !== undefined) {
    // Remove item
    swatchbookData.items.splice(at, 1);
    // Update data object in storage
    window.localStorage.setItem(swatchbookLsObj, JSON.stringify(swatchbookData));
  }
  updateNavIcon();
};

const localStorageSwatchEventHandlers = (item) => {
  if (!item) {
    return;
  }
  const id = item.getAttribute('id');
  const btn = item.querySelector('.swatchbutton');
  const label = item.querySelector('.swatchbutton--label');
  if (btn) {
    // Toggle button to remove state if in swatchbook
    if (getItemById(id) !== null) {
      btn.classList.add('is-active');
      label.innerHTML = 'Remove Swatch';
    } else {
      btn.classList.remove('is-active');
      label.innerHTML = 'Add Swatch';
    }
    // Add/remove swatch event handlers
    btn.addEventListener('click', (event) => {
      event.stopPropagation();
      // Remove
      if (btn.classList.toString().indexOf('is-active') !== -1) {
        removeSwatchbookItem({
          type: 'swatch',
          value: id,
        });
        btn.classList.remove('is-active');
        label.innerHTML = 'Add Swatch';
        // Add
      } else {
        const data = {
          collection: btn.getAttribute('data-collection'),
          colorName: btn.getAttribute('data-colorName'),
          colorNumber: btn.getAttribute('data-colorNumber'),
          id: btn.getAttribute('data-id'),
          imageUrl: btn.getAttribute('data-imageUrl'),
          productLine: btn.getAttribute('data-productLine'),
          productLineCode: btn.getAttribute('data-productLineCode'),
          styleId: btn.getAttribute('data-styleId'),
          swatchCatId: btn.getAttribute('data-swatchCatId'),
          swatchCatName: btn.getAttribute('data-swatchCatName'),
          swatchStyleName: btn.getAttribute('data-swatchStyleName'),
          swatchId: btn.getAttribute('data-swatchId'),
          newSwatch: btn.getAttribute('data-new-swatch'),
          displayMessage: btn.getAttribute('data-display-message'),
          type: btn.getAttribute('data-type'),
          widenUrl: getTruncatedWidenUrl(btn.getAttribute('data-imageUrl')),
        };
        saveSwatchbookItem(data);
        btn.classList.add('is-active');
        label.innerHTML = 'Remove Swatch';
      }
    });
  }
};

const addSwatchToCart = (id) => {
  if (getSwatchbookData === null) {
    init(); /* eslint-disable-line no-use-before-define */
  }
  if (swatchbookData.cart.indexOf(id) === -1) {
    swatchbookData.cart.push(id);
    window.localStorage.setItem(swatchbookLsObj, JSON.stringify(swatchbookData));
  }
};

const removeSwatchFromCart = (id) => {
  const at = swatchbookData.cart.findIndex(saved => saved === id);
  if (at !== -1) {
    // Remove item
    swatchbookData.cart.splice(at, 1);
    // Update data object in storage
    window.localStorage.setItem(swatchbookLsObj, JSON.stringify(swatchbookData));
  }
};

const clearSwatchbook = () => {
  if (swatchbookData === null) {
    return;
  }
  swatchbookData.items = [];
  window.localStorage.setItem(swatchbookLsObj, JSON.stringify(swatchbookData));
};

const clearCart = () => {
  if (swatchbookData === null) {
    return;
  }
  swatchbookData.cart = [];
  window.localStorage.setItem(swatchbookLsObj, JSON.stringify(swatchbookData));
};

const updateOrderData = (data) => {
  swatchbookData.order = data;
  window.localStorage.setItem(swatchbookLsObj, JSON.stringify(swatchbookData));
};

const clearOrderData = () => {
  swatchbookData.cart = [];
  swatchbookData.order = [];
  window.localStorage.setItem(swatchbookLsObj, JSON.stringify(swatchbookData));
};

const destroy = () => {
  swatchbookData = null;
};

const clearAllSwatchbookData = () => {
  if (!swatchbookData) {
    swatchbookData = getSwatchbookData();
  }
  clearOrderData();
  clearSwatchbook();
  destroy();
};

const init = () => {
  swatchbookData = getSwatchbookData();
  // console.log(swatchbookData);
  if (window.useLocalStorage) {
    updateNavIcon();
  } else {
    updateAccountIconStatus();
  }
};

const getProductDetailsPageUrl = (productLineId, callback) => {
  const requestUrl = `/GetProductDetailsUrl?productLineId=${productLineId}`;
  const request = new XMLHttpRequest();
  request.open('GET', requestUrl, true);
  request.setRequestHeader('Content-type', 'application/json');
  request.onload = () => {
    if (request.status >= 200 && request.status < 400) {
      const responseData = JSON.parse(request.responseText);
      if (callback) {
        callback(responseData.url);
      }
    }
  };
  request.onerror = () => {
    console.log('error');
  };
  request.send();
};

const getSwatchProductUrlParams = (productName, callback) => {
  // If visualizer isn't active immediately run the callback method
  if (!window.isVisualizerActive) {
    callback();
    return;
  }
  // console.log(productName.toLowerCase());
  // Pass product name (lc) to get visualization url params...
  const requestUrl = `/GetVisualizationProperties?pagename=${productName.toLowerCase()}`;
  const request = new XMLHttpRequest();
  request.open('GET', requestUrl, true);
  request.setRequestHeader('Content-type', 'application/json');
  request.onload = () => {
    if (request.status >= 200 && request.status < 400) {
      const responseData = JSON.parse(request.responseText);
      if (callback) {
        callback({
          visualizerModelId: responseData.VisualizerModelId,
          visualizerProgamFamilyName: responseData.VisualizerProgramFamilyName,
        });
      }
    }
  };
  request.onerror = () => {
    console.log('error');
  };
  request.send();
};

export {
  saveItem,
  removeItem,
  getTruncatedWidenUrl,
  saveSwatchbookItem,
  decodeSwatchModalTableDataById,
  removeSwatchbookItem,
  localStorageSwatchEventHandlers,
  addSwatchToCart,
  removeSwatchFromCart,
  getSwatchbookData,
  getItemById,
  getAllOfType,
  updateOrderData,
  getUserData,
  clearAllSwatchbookData,
  clearCart,
  clearOrderData,
  clearSwatchbook,
  getSwatchProductUrlParams,
  getProductDetailsPageUrl,
  init,
  destroy,
};
/* eslint-enable no-console */
